import axiosInstance from "../../api/axiosInstance";
import publicAxios from "../../api/publicAxios";

// ── Browsing (public — no auth required) ──────────────────
export const fetchActiveCourses = () =>
  publicAxios.get("/client/courses");

export const fetchCourseById = (courseId) =>
  publicAxios.get(`/client/courses/${courseId}`);

export const fetchCourseBySlug = (slug) =>
  publicAxios.get(`/client/courses/slug/${slug}`);

// ── Enrollment ────────────────────────────────────────────
export const requestEnrollment = (batchId) =>
  axiosInstance.post("/client/courses/enroll/request", { batchId });

export const checkBatchEnrollment = (batchId) =>
  axiosInstance.get("/client/courses/enroll/check", { params: { batchId } });

// ── My Courses ────────────────────────────────────────────
export const fetchMyEnrollments = () =>
  axiosInstance.get("/client/courses/my-enrollments");

export const fetchEnrollmentDetail = (enrollmentId) =>
  axiosInstance.get(`/client/courses/my-enrollments/${enrollmentId}`);

export const fetchEnrollmentAssessments = (enrollmentId) =>
  axiosInstance.get(`/client/courses/my-enrollments/${enrollmentId}/assessments`);

export const fetchAllMyAssessments = () =>
  axiosInstance.get(`/client/assessments`);

export const fetchAllEnrollmentAssessments = (enrollmentId) =>
  axiosInstance.get(`/client/courses/my-enrollments/${enrollmentId}/assessments/all`);

export const fetchLessonAssessmentClient = (enrollmentId, curriculumId) =>
  axiosInstance.get(`/client/courses/my-enrollments/${enrollmentId}/assessments/lesson/${curriculumId}`);

// ── Demo ──────────────────────────────────────────────────
export const requestDemo = (courseId, data) =>
  axiosInstance.post(`/client/courses/demo/${courseId}/request`, data);

export const fetchDemoRequest = (courseId) =>
  axiosInstance.get(`/client/courses/demo/${courseId}/request`);

// ── Study Materials ───────────────────────────────────────
export const fetchCurriculumContentClient = (curriculumId) =>
  publicAxios.get(`/client/courses/curriculum/${curriculumId}/content`);
